import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isVoiceEnabled: false,
  aiResponseMessage: '',
  isAiResponseLoading: false,
};

const aiResponseSlice = createSlice({
  name: 'aiResponse',
  initialState,
  reducers: {
    setAiResponseMessage: (state, action) => {
      state.aiResponseMessage = action.payload;
    },
    setIsVoiceEnabled: (state, action) => {
      state.isVoiceEnabled = action.payload;
    },
    clearAiResponseMessage: (state) => {
      state.aiResponseMessage = '';
    },
    setIsAiResponseLoading: (state, action) => {
      state.isAiResponseLoading = action.payload;
    },
  },
});

export const { setAiResponseMessage, setIsVoiceEnabled, clearAiResponseMessage, setIsAiResponseLoading } = aiResponseSlice.actions;

export default aiResponseSlice.reducer;
